/* eslint-disable no-new */
import * as utilUpgradeMember from '@/api/upgradeMember'

const state = { 
  membertypeOpts: []
};

const mutations = {
  SET_membertypeOpts: (state, value) => {
    state.membertypeOpts = value;
  },
};

const actions = {
  membershipOptions({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      utilUpgradeMember.membershipOptions(dataParams).then(response => {
        const { data } = response;
        commit("SET_membertypeOpts", data);
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  upgradeMembershipValidate({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      utilUpgradeMember.upgradeMembershipValidate(dataParams)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },

  upgradeMembershipStored({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      utilUpgradeMember.upgradeMembershipStored(dataParams)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/upgradeMember.js